import React from 'react';
import auth from '@ifeng-fe/ui_pc_auth';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { newFaceImgList } from '../../../../../../../utils/utils.js';
import { postComment } from '../../../../../../../services/api.js';

const text = ['文明上网，不传谣言！', '文明上网，不传谣言，登录评论！'];

class CommentTextareaBody extends React.PureComponent {
    static propTypes = {
        userInfo: PropTypes.object,
        loginId: PropTypes.string,
        config: PropTypes.object,
    };
    state = {
        value: '',
        inserting: false,
        faceBoxShow: false,
        success: false,
        bigFaceShow: '',
        bigFace: '',
        bigFaceTitle: '',
    };

    componentDidMount() {
        const text = this.props.userInfo ? '文明上网，不传谣言！' : '文明上网，不传谣言，登录评论！';

        this.setState({
            value: text,
        });
    }

    static getDerivedStateFromProps(props, state) {
        if (!state.inserting && text.indexOf(state.value) > -1) {
            return {
                value: props.userInfo ? '文明上网，不传谣言！' : '文明上网，不传谣言，登录评论！',
            };
        }

        return null;
    }

    handleChange = e => {
        const value = (e.currentTarget && e.currentTarget.value) || '';

        this.setState({
            value,
        });
    };

    handleFocus = () => {
        const { value } = this.state;
        const text = this.props.userInfo ? '文明上网，不传谣言！' : '文明上网，不传谣言，登录评论！';

        this.setState({
            value: value === text ? '' : value,
            inserting: true,
        });
    };

    handleBlur = () => {
        const { value } = this.state;
        const text = this.props.userInfo ? '文明上网，不传谣言！' : '文明上网，不传谣言，登录评论！';

        this.setState({
            value: value === '' ? text : value,
            inserting: false,
        });
    };

    handleFaceBoxShow = () => {
        const { faceBoxShow } = this.state;

        this.setState({ faceBoxShow: !faceBoxShow });
    };

    // 提交评论内容
    handleSubmit = () => {
        // 已经登录，且已经实名，则可以发表评论
        if (auth.isReal()) {
            const content = this.state.value;

            if (content === '' || text.indexOf(content) > -1) {
                window.alert('请填写评论内容！');
            } else if (content.length > this.props.config.cmtLength) {
                window.alert('评论内容过长，超过最大限制1000个字符！');
            } else {
                this.postContent(content);
            }
        } else {
            if (auth.isLogin()) {
                window.alert('您还没有实名认证，请先进行实名认证');
            }
            alert('您还没有登录，请先登录');

            auth.login(this.props.loginId);
        }
    };

    // 提交评论
    postContent = async content => {
        try {
            const data = await postComment(content, this.props.config);

            if (data.code === 1) {
                this.setState({
                    value: this.props.userInfo ? '文明上网，不传谣言！' : '文明上网，不传谣言，登录评论！',
                    success: true,
                    inserting: false,
                });

                // 评论成功,内容显示为最初的提示语，同时显示评论成功提示
                // 要清除定时器
                if (this.timer) {
                    clearTimeout(this.timer);
                }

                this.timer = window.setTimeout(() => {
                    this.setState({
                        success: false,
                    });
                }, 1000);
            } else if (data.message && data.message.length > 0) {
                window.alert(data.message);
            }
        } catch (e) {
            console.error(e);
        }
    };

    handleFaceInsert = e => {
        const { value } = this.state;
        const faceTitle = e.currentTarget && e.currentTarget.attributes['title'].value;
        const text = this.props.userInfo ? '文明上网，不传谣言！' : '文明上网，不传谣言，登录评论！';

        const content = `${value === text ? '' : value}[${faceTitle}]`;

        this.setState({
            value: content,
            inserting: true,
        });
    };

    handleMouseOver = e => {
        const index = Number(e.currentTarget && e.currentTarget.attributes['data-index'].value);
        const bigFace = (e.currentTarget && e.currentTarget.attributes['data-img'].value) || '';
        const bigFaceTitle = (e.currentTarget && e.currentTarget.attributes['data-title'].value) || '';
        let bigFaceShow = '';

        if ([7, 8, 9, 17, 18, 19].indexOf(index) > -1) {
            bigFaceShow = 'left';
        } else {
            bigFaceShow = 'right';
        }

        this.setState({
            bigFaceShow,
            bigFace,
            bigFaceTitle,
        });
    };

    handleMouseOut = () => {
        this.setState({
            bigFaceShow: '',
            bigFace: '',
            bigFaceTitle: '',
        });
    };

    render() {
        const { value, inserting, faceBoxShow, success, bigFaceShow, bigFace, bigFaceTitle } = this.state;

        const stylesArr = styles;

        return (
            <div className={styles.comment_textarea_body}>
                <div className={styles.textarea_box}>
                    <textarea
                        className={styles.comment_area}
                        style={{ color: inserting ? '#000' : '#999' }}
                        cols={30}
                        rows={10}
                        value={value}
                        onChange={this.handleChange.bind(this)}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                    />
                    <span className={styles.arr_up} />
                    {success ? <div className={styles.comment_success}>评论成功</div> : ''}
                </div>
                <div className={styles.submit_bar}>
                    <a className={styles.submit_btn} onClick={this.handleSubmit}>
                        发表评论
                    </a>
                    <div className={styles.comment_face_box}>
                        <div className={styles.comment_face}>
                            <a className={styles.face_trigger} onClick={this.handleFaceBoxShow}>
                                <span className={styles.face_btn} />
                                <span className={styles.icon} />
                            </a>
                            {faceBoxShow ? (
                                <div className={styles.face_box}>
                                    <div className={styles.faceB}>
                                        <div className={styles.face_list}>
                                            <span className={styles.arr} />
                                            <ul className={styles.faceimg_list} onMouseOut={this.handleMouseOut}>
                                                {newFaceImgList.map((item, index) => (
                                                    <li
                                                        key={index}
                                                        data-index={index}
                                                        data-img={item.class}
                                                        data-title={item.title}
                                                        onMouseOver={this.handleMouseOver.bind(this)}>
                                                        <span
                                                            className={stylesArr[item.class]}
                                                            title={item.name}
                                                            onClick={this.handleFaceInsert.bind(this)}
                                                        />
                                                    </li>
                                                ))}
                                            </ul>
                                            {bigFaceShow !== '' ? (
                                                <div
                                                    className={`${
                                                        bigFaceShow === 'left' ? styles.big_faceL : styles.big_faceR
                                                    } ${styles.big_face}`}>
                                                    <span className={stylesArr[bigFace]} title={bigFaceTitle} />
                                                    <p>{bigFaceTitle}</p>
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(CommentTextareaBody);
